export default () => [
  {
    field: 'seq',
    minWidth: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    minWidth: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    minWidth: 170,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'icechopsNo',
    align: 'center',
    fixed: 'left',
    minWidth: 150,
    title: '冰排编号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'icechopsLength',
    align: 'center',
    minWidth: 110,
    title: '冰排长度',
    sortable: true,
    sortType: 'float',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'icechopsWidth',
    align: 'center',
    minWidth: 110,
    title: '冰排宽度',
    sortable: true,
    sortType: 'float',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'icechopsHeight',
    align: 'center',
    minWidth: 110,
    title: '冰排高度',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'v_tempRange',
    align: 'center',
    minWidth: 150,
    title: '温度范围',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orderNo',
    align: 'center',
    minWidth: 160,
    title: '原订单编号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'dispatchOrderNo',
    align: 'center',
    minWidth: 160,
    title: '调度订单编号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'bizBillNo',
    align: 'center',
    minWidth: 160,
    title: '客户单号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'waybillNo',
    align: 'center',
    minWidth: 160,
    title: '运单编号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'coolerNo',
    align: 'center',
    minWidth: 160,
    title: '冷藏箱编号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'v_inFreezerStatus',
    align: 'center',
    minWidth: 100,
    title: '在柜状态',
    slots: { default: 'inFreezerStatus' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'inFreezerLocationNo',
    align: 'center',
    minWidth: 150,
    title: '入柜库位',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'inFreezerOptByName',
    align: 'center',
    width: 100,
    title: '入柜操作人',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'inFreezerTime',
    align: 'center',
    width: 170,
    title: '入柜时间',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'freezeTime',
    align: 'center',
    title: '冷冻时间',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'outFreezerLocationNo',
    align: 'center',
    minWidth: 150,
    title: '出柜库位',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'outFreezerOptByName',
    align: 'center',
    width: 100,
    title: '出柜操作人',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'outFreezerTime',
    align: 'center',
    width: 170,
    title: '出柜时间',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'thawTime',
    align: 'center',
    title: '释冷时间',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'inTransitTime',
    align: 'center',
    title: '在途时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'v_icechopsStatus',
    align: 'center',
    minWidth: 100,
    title: '有效状态',
    slots: { default: 'status' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createByName',
    align: 'center',
    width: 100,
    title: '创建人',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createTime',
    align: 'center',
    width: 170,
    title: '创建时间',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyByName',
    align: 'center',
    minWidth: 100,
    title: '修改人',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyTime',
    align: 'center',
    width: 170,
    title: '修改时间',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
